import React, { useState, useEffect } from 'react';
import '../../css/leadCard.css';
import { useSelector } from 'react-redux';
import WorkflowInfo from '../workflow/workflowInfo';
import LeadCardAppointments from '../appointment/leadCardAppointments';

import TagComponent from '../tags/tagComponent';
import LeadCardTags from './tags';
import { formatTimestamp } from '../../utilities/dashFunction';
import Icon from '../../assets/icons/icon';
import resetIcon from '../../assets/icons/ResetIcon.svg';
import { fetchWithDefaults } from '../../config/fetchDefault';

function LeadCardHeader() {

    const [selectedTags, setSelectedTags] = useState([]);
    const [syncModalVisible, setSyncModalVisible] = useState(false);
    const [viewAppointments, setViewAppointments] = useState(false);
    const [dataSynced , setDataSynced] = useState(false)
    const [syncMsgVisible , setSyncMsgVisible] = useState(false)
    // ===== leads popup full data =====
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const agentId = useSelector((state) => state.agent.userData).agentId;
    
    const leadStatusArray = useSelector((state) => state.leadInfo.leadStatusArray);
    // Find the entry that matches the selected leadId
    const leadNameInfo = leadStatusArray.find((leads) => leads.leadId === leadsAlldata.lead_id);
    // ===========
    const activityApointmentArray = useSelector((state) => state.scheduledCallInfo?.appointmentsArray);

    const selectedLeadAppointment = leadsAlldata && activityApointmentArray?.data.filter(item => item.apptLead === leadsAlldata?.lead_id);

    const handleAppointmentView = () => {
        setViewAppointments(true)
    }
    const handleConfirmSyncData = async (e) => {
        e.preventDefault();
      
        try {
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              agent: `${agentId}`,
              lead: leadsAlldata?.lead_id,
            }),
          };
      
          const response = await fetchWithDefaults(`/lead/syncFromActivate`, requestOptions);
      
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
      
          const jsonData = await response.json();
      
          if (jsonData.success) {
            setDataSynced(true);
          } else {
            setDataSynced(false);
          }
      
        } catch (error) {
          console.error("Error fetching data:", error);
          setDataSynced(false);
        } finally {
          setSyncMsgVisible(true);
          setSyncModalVisible(false);
        }
      };
      

    return (
        leadsAlldata && (
            <>
                <div className="leadCardHeader" >
    
                {syncMsgVisible &&  (!dataSynced ? (<div className='syncMsgUpdate' style={{background : '#FEF3F2' , border: '1px solid #F95951'}}>
                    <svg className='syncIcon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                     <path d="M12 8V12M12 16H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z" stroke="#F95951" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                     <span className='syncMsgUpdateText' style={{color: '#F95951'}}>
                        The Activate Data sync was not able to be completed. Please try again or reach out to support for more information.
                      </span>
                      <svg className='syncIcon' style={{marginLeft : 'auto' , cursor:'pointer'}} onClick={()=> setSyncMsgVisible(false)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="#F95951" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                </div>) :
                (<div className='syncMsgUpdate'style={{background : '#ECFDF3' , border: '1px solid #17B26A'}}>
                     <svg className='syncIcon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                     <path d="M20 6L9 17L4 12" stroke="#17B26A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span className='syncMsgUpdateText' style={{color: '#17B26A'}}>
                         Your Activate Data sync has been completed
                      </span>
                      <svg className='syncIcon' style={{marginLeft : 'auto' , cursor:'pointer'}} onClick={()=> setSyncMsgVisible(false)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="#17B26A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                </div>)
                )
             }
                    <span className="leadName">{leadsAlldata.borrower_first ? leadsAlldata.borrower_first.replace(/\\/g, '') : 'unknown'} {leadsAlldata.borrower_last ? leadsAlldata.borrower_last.replace(/\\/g, '') : 'unknown'}</span>
             {leadsAlldata.in_activate === 1 && <span style={{marginLeft : '15px' , display : 'inline-flex' , alignItems:'center', gap:'5px'}} >
                       <img src={resetIcon} alt="Reset Icon"/>
                       <span className='syncLead' onClick={(e)=> setSyncModalVisible(true)}>Sync Activate Data</span>
                    </span>}
                    
                    <LeadCardTags leadId={leadsAlldata.lead_id} />
                    <div style={{ position: 'absolute', right: '0', top: '0', width: '50px' }}><TagComponent leadId={leadsAlldata?.lead_id} /></div>

                    {
                        selectedLeadAppointment?.length > 0 && <div className="tagIcon " style={{ position: 'absolute', right: '-12px', marginTop: '-22px', cursor: "pointer" }} onClick={() => handleAppointmentView()}>
                            <span className="fontello" style={{ marginRight: '5px', lineHeight: '0px' }}><Icon name={'calendar-date-selection-q'} size={20} height='24' className="" adjust="fontello" /></span>
                        </div>
                    }

                </div>

                {
                    leadNameInfo != undefined ? <span className="statusName">{leadNameInfo.data.status_name}</span>
                        : <span className="statusName">{leadsAlldata.status_name}</span>
                }
                <div className="leadCardAddressWrapper">
                    <div className="addressHolder">
                        <span className="addressSlot">{leadsAlldata.address + ',' ?? 'Click To Add'}</span>
                        <span className="addressSlot">{leadsAlldata.city + ',' ?? 'Click To Add'}</span>
                        <span className="addressSlot">{leadsAlldata.state ?? 'Click To Add'}</span>
                        <span className="addressSlot">{leadsAlldata.zip ?? 'Click To Add'}</span>
                    </div>
                    <div className="badgeHolder">
                        <span className="queueInnerBadgeHolder">
                            {leadsAlldata.wf_name && (
                                <WorkflowInfo type='workflow' title={leadsAlldata.wf_name} workflowId={leadsAlldata.wf_id} hopperId={leadsAlldata.wf_hopper_id} />
                            )}
                            {leadsAlldata.convoFlowName && (
                                <WorkflowInfo type='conversation' title={leadsAlldata.convoFlowName} workflowId={leadsAlldata.pathway} hopperId={leadsAlldata.wf_hopper_id} />
                            )}
                            {leadsAlldata.lead_type && <span className="badgeButton">Lead Type <span style={{ fontWeight: 'normal' }}>{leadsAlldata.lead_type}</span></span>}
                            {leadsAlldata.lead_level && <span className="badgeButton">Lead Level <span style={{ fontWeight: 'normal' }}>{leadsAlldata.lead_level}</span></span>}
                        </span>
                    </div>
                    {leadsAlldata.exclusivity && (
                        <div className="exclusivity" style={{ marginTop: 'unset' }}>Exclusive until - {formatTimestamp(leadsAlldata.exclusivity)}</div>
                    )}
                </div>
                {viewAppointments && (
                    <LeadCardAppointments setViewAppointments={setViewAppointments} appointments={leadsAlldata.appointments} lead={leadsAlldata.lead_id} />
                )}

              { syncModalVisible && <div className="modal-overlay">
                    <div className="modal-box">
                    <svg onClick={(e)=> setSyncModalVisible(false)} className='close-icon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h2>Sync Activate Data</h2>
                    <p>Click confirm to import any conversations, tags, notes, and contact recordings you had in Activate into this lead card.</p>
                    <div class="button-group">
                        <button className="button cancel-button" onClick={(e)=> setSyncModalVisible(false)}>Cancel</button>
                        <button className="button confirm-button" onClick={handleConfirmSyncData}>Confirm</button>
                    </div>
                </div>
                </div>}
            </>
        )
    )
}

export default LeadCardHeader;